import { render } from "./ConfigureSettings.vue?vue&type=template&id=1f70b318&scoped=true&ts=true"
import script from "./ConfigureSettings.vue?vue&type=script&lang=ts"
export * from "./ConfigureSettings.vue?vue&type=script&lang=ts"

import "./ConfigureSettings.vue?vue&type=style&index=0&id=1f70b318&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f70b318"]])

export default __exports__